import Link from 'next/link';
import AuthorName from '../../General/AuthorName';
import ProfileAvatar from '../../Profile/ProfileAvatar';
import CreationTime from '../CreationTime';
import DotMenu from '../DotMenu';

// Centered author byline: avatar, name with role badges, build-stable date
// + read time, and the post dot menu. Shared by the paper header and the
// cinematic masthead so the byline can never drift between hero modes.
export default function AuthorRow({
  author,
  createdAt,
  readTime,
  permlink,
  title,
  thumbnail,
  tags,
  editLink,
}) {
  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-gap-3">
      <Link href={`/@${author.username}`} prefetch={false}>
        <ProfileAvatar
          authorAvatar={author.avatar}
          author={author.username}
          size={48}
        />
      </Link>
      <div className="tw-text-left">
        <Link
          href={`/@${author.username}`}
          prefetch={false}
          className="tw-text-[15px] tw-font-semibold tw-text-[#1D2D28] dark:tw-text-[#EBE6D9] tw-no-underline hover:tw-text-primary-700 dark:hover:tw-text-primary-300"
        >
          <AuthorName author={author} />
        </Link>
        <p className="tw-m-0 tw-font-mono tw-text-[11px] tw-tracking-wider tw-text-[#8A958F]">
          <CreationTime createdAt={createdAt ? String(createdAt) : undefined} />
          {readTime ? <> · {Math.ceil(readTime)} MIN READ</> : null}
        </p>
      </div>
      <DotMenu
        editLink={editLink}
        author={author.username}
        permlink={permlink}
        title={title}
        thumbnail={thumbnail}
        tags={tags}
      />
    </div>
  );
}
